import {
  sendGetHttpRequest,
  sendPostHttpRequest,
  sendHttpRequest,
} from "lib/fetcher";
import Cookies from "js-cookie";
import { SALT } from "lib/constants";
import { argon2id } from "lib/utils";

export async function getUserProfile(orgId?: string) {
  return await sendGetHttpRequest(`/user/profile`, orgId);
}

export async function updateUserProfile(data: any, orgId?: string) {
  return await sendHttpRequest({
    method: "patch",
    url: "/user/profile",
    data: data,
    headers: {
      "Content-Type": "application/json",
      "x-org-id": orgId ?? Cookies.get("orgId"),
    },
  });
}

export async function bindSso(
  authCode: string,
  ssoType: string,
  orgId?: string,
) {
  return await sendPostHttpRequest(
    "/auth/bind_sso",
    {
      ssoCredential: {
        authCode,
        ssoType,
      },
    },
    orgId ?? Cookies.get("orgId"),
  );
}

export async function unBindSso(ssoType: string, orgId?: string) {
  return await sendPostHttpRequest(
    "/auth/unbind_sso",
    {
      ssoType,
    },
    orgId ?? Cookies.get("orgId"),
  );
}

export async function changePwd(
  email: string,
  newPassword: string,
  oldPassword,
  orgId?: string,
) {
  const passSalt = await argon2id(email, SALT, 16);
  const lowerPassSalt = await argon2id(email.toLocaleLowerCase(), SALT, 16);
  const lowerOldPassHash = await argon2id(oldPassword, lowerPassSalt, 32);
  //const lowerNewPassHash = await argon2id(newPassword, lowerPassSalt, 32);
  const oldPassHash = await argon2id(oldPassword, passSalt, 32);
  const newPassHash = await argon2id(newPassword, passSalt, 32);

  return await sendPostHttpRequest(
    "/auth/change_password",
    {
      newPassword: newPassHash,
      oldPassword: oldPassHash,
      old_password_v2: lowerOldPassHash,
    },
    orgId ?? Cookies.get("orgId"),
  );
}
